// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.currency[data-v-beb396c0] svg {\n\tposition: absolute;\n\tleft: 1em;\n\ttop: 0.5em;\n\tcolor: #4a4a4a;\n}\n", ""]);
// Exports
module.exports = exports;
